export default () => {
  return {
    breadcrumbs: [],
  };
};
